import {Logo} from '@/components/common/carousel/types'
import {Region} from '@/utils/countries'

const clientLogos: Record<number, Logo> = {
  1: {
    imageAlt: 'GymBeam',
    imageSrc: '/images/client-logos/gymbeam-logo.png',
    linkHref: 'https://gymbeam.com',
  },
  2: {
    imageAlt: 'Kickresume',
    imageSrc: '/images/client-logos/kickresume-logo.png',
    linkHref: 'https://www.kickresume.com',
  },
  3: {
    imageAlt: 'Monk',
    imageSrc: '/images/client-logos/monk-logo.png',
    linkHref: 'https://www.monk.sk',
  },
  4: {
    imageAlt: 'Hlbina',
    imageSrc: '/images/client-logos/hlbina-logo.png',
    linkHref: 'https://hlubina.shop',
  },
  5: {
    imageAlt: 'Horamy',
    imageSrc: '/images/client-logos/horamy-logo.png',
    linkHref: 'https://www.horamy.sk',
  },
  6: {
    imageAlt: 'Webgate',
    imageSrc: '/images/client-logos/webgate-logo.png',
    linkHref: 'https://webgate.digital',
  },
  7: {
    imageAlt: 'Klobasky',
    imageSrc: '/images/client-logos/klobasky-logo.png',
    linkHref: 'https://www.klobasky.sk',
  },
  8: {
    imageAlt: 'MojPobox',
    imageSrc: '/images/client-logos/mojpobox-logo.png',
    linkHref: 'https://www.mojpobox.sk',
  },
  9: {
    imageAlt: 'EMI',
    imageSrc: '/images/client-logos/emi-logo.png',
    linkHref: 'https://emi.sk',
  },
  10: {
    imageAlt: 'Quell',
    imageSrc: '/images/client-logos/quell-logo.png',
    linkHref: 'https://www.quell.sk',
  },
  11: {
    imageAlt: 'Space brokers',
    imageSrc: '/images/client-logos/space-brokers-logo.png',
    linkHref: 'https://spacebrokers.cz',
  },
  12: {
    imageAlt: 'Iscribo',
    imageSrc: '/images/client-logos/iscribo-logo.png',
    linkHref: 'https://iscribo.com',
  },
  13: {
    imageAlt: 'Perida',
    imageSrc: '/images/client-logos/perida-logo.png',
    linkHref: 'https://www.perida.sk',
  },
  14: {
    imageAlt: 'Unipas',
    imageSrc: '/images/client-logos/unipas-logo.png',
    linkHref: 'https://www.unipas.com',
  },
  15: {
    imageAlt: 'Deepnote',
    imageSrc: '/images/client-logos/deepnote-logo.png',
    linkHref: 'https://deepnote.com',
  },
  16: {
    imageAlt: 'Aim-for',
    imageSrc: '/images/client-logos/aim-for-logo.png',
    linkHref: 'https://aim-for.com',
  },
  17: {
    imageAlt: 'Delivro',
    imageSrc: '/images/client-logos/delivro-logo.png',
    linkHref: 'https://delivro.cz',
  },
  18: {
    imageAlt: 'Kolor',
    imageSrc: '/images/client-logos/kolor-logo.png',
    linkHref: 'https://www.kolor.cz',
  },
  19: {
    imageAlt: 'Sloneek',
    imageSrc: '/images/client-logos/sloneek-logo.png',
    linkHref: 'https://www.sloneek.com',
  },
  20: {
    imageAlt: 'Nag',
    imageSrc: '/images/client-logos/nag-logo.png',
    linkHref: 'https://nag.com',
  },
  21: {
    imageAlt: 'Beviro',
    imageSrc: '/images/client-logos/beviro-logo.png',
    linkHref: 'https://www.beviro.com',
  },
  22: {
    imageAlt: 'Datapacket',
    imageSrc: '/images/client-logos/datapacket-logo.png',
    linkHref: 'https://www.datapacket.com',
  },
  23: {
    imageAlt: 'Omniwave',
    imageSrc: '/images/client-logos/omniwave-logo.png',
    linkHref: 'https://bloomline.com',
  },
  24: {
    imageAlt: 'Expressgrass',
    imageSrc: '/images/client-logos/expressgrass-logo.png',
    linkHref: 'https://expressgrass.com',
  },
  25: {
    imageAlt: 'Cadastra',
    imageSrc: '/images/client-logos/cadastra-logo.png',
    linkHref: 'https://en.cadastra.com',
  },
  26: {
    imageAlt: 'Qualee',
    imageSrc: '/images/client-logos/qualee-logo.png',
    linkHref: 'https://www.qualee.com',
  },
  27: {
    imageAlt: 'Cledara',
    imageSrc: '/images/client-logos/cledara-logo.png',
    linkHref: 'https://www.cledara.com',
  },
  28: {
    imageAlt: 'Tapkit',
    imageSrc: '/images/client-logos/tapkit-logo.png',
    linkHref: 'https://tapkit.com',
  },
  29: {
    imageAlt: 'Buildiro',
    imageSrc: '/images/client-logos/buildiro-logo.png',
    linkHref: 'https://buildiro.com',
  },
  30: {
    imageAlt: 'Plank Hardware',
    imageSrc: '/images/client-logos/plank-logo.png',
    linkHref: 'https://plankhardware.com',
  },
  31: {
    imageAlt: 'Scalenordic',
    imageSrc: '/images/client-logos/scalenordic-logo.png',
    linkHref: 'https://www.scalenordic.no',
  },
  32: {
    imageAlt: 'Panaxeo',
    imageSrc: '/images/client-logos/panaxeo-logo.png',
    linkHref: 'https://www.panaxeo.com',
  },
  33: {
    imageAlt: 'Gymtier',
    imageSrc: '/images/client-logos/gymtier-logo.png',
    linkHref: 'https://de.gymtier.com',
  },
  34: {
    imageAlt: 'Ruchie',
    imageSrc: '/images/client-logos/ruchie-logo.png',
    linkHref: 'https://www.ruchie.co.uk/',
  },
  35: {
    imageAlt: 'Eavolve',
    imageSrc: '/images/client-logos/eavolve-logo.png',
    linkHref: 'https://www.eavolve.co.uk',
  },
  36: {
    imageAlt: 'Springboard',
    imageSrc: '/images/client-logos/springboard-logo.png',
    linkHref: 'https://springboard.uk.net/',
  },
  37: {
    imageAlt: 'Forzet',
    imageSrc: '/images/client-logos/forzet-logo.png',
    linkHref: 'https://www.forzet.sk',
  },
  38: {
    imageAlt: 'Cinelli',
    imageSrc: '/images/client-logos/cinelli-logo.png',
    linkHref: 'https://cinelli-milano.com',
  },
  39: {
    imageAlt: 'Collaborator',
    imageSrc: '/images/client-logos/collaborator-logo.png',
    linkHref: 'https://collaborator.pro',
  },
  40: {
    imageAlt: 'Nevron',
    imageSrc: '/images/client-logos/nevron-logo.png',
    linkHref: 'https://nevron.io',
  },
  41: {
    imageAlt: 'Agaru',
    imageSrc: '/images/client-logos/agaru-logo.png',
    linkHref: 'http://agarusport.com',
  },
}

const orderSK = [1, 2, 4, 6, 8, 5, 7, 9, 37, 10, 11, 12, 13, 14, 15, 16]
const orderCZ = [1, 2, 17, 18, 3, 5, 7, 9, 37, 10, 11, 12, 13, 14, 15, 16]
const orderDefault = [1, 2, 15, 38, 26, 20, 27, 25, 28, 39, 40, 22, 41, 32, 21, 36, 35]

export const useClientLogos = (region: Region) =>
  (region === Region.SK ? orderSK : region === Region.CZ ? orderCZ : orderDefault).map(
    (item) => clientLogos[item],
  )
